{
  "shellWaitLabel": "読み込み中"
}
